import { atom } from "recoil";
import { SortationStateKey } from "sortation/base/SortationStateKeys";
import { BrowserPrintDevice } from "./BrowserPrintTypes";

// UID of printer
export const desktopPrinterState = atom<BrowserPrintDevice | null>({
  key: SortationStateKey.DESKTOP_PRINTER,
  default: null,
});
